import React from 'react'

export default ({
  renderGeneralInfoForm,
  renderGeneralInfoFormContact,
  renderGeneralInfoFormLocation,
}) => (
  <div className="section">
    <h1 className="title is-3"> ข้อมูลทั่วไป</h1>
    {renderGeneralInfoForm}
    <hr />
    <h1 className="title is-3"> ข้อมูลติดต่อ</h1>
    {renderGeneralInfoFormContact}
    <hr />
    <h1 className="title is-3"> สถานที่ </h1>
    {renderGeneralInfoFormLocation}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoLayout.js